exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n\n#o2-chart-1 {\n\tfloat: left;\n\tmin-width: 50% !important;\n}\n\n#o2-chart-2 {\n\tfloat: right;\n\tmin-width: 50% !important;\n}\n\n#o2-chart-1 path, #o2-chart-2 path {\n\tfill: rgb(255, 255, 255);\n\tstroke: rgb(0, 0, 0);\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/ingvars/BNC-Lab/front/src/app/map/map.component.css
// module id = ../../../../../src/app/map/map.component.css
// module chunks = 0